import { styled } from '@mui/material'

import { IconButton } from '@collaborate-health/uikit'

export const MenuIconButton = styled(IconButton)(({ theme }) => ({
  marginBlock: theme.spacing(-1),
  marginLeft: theme.spacing(-0.5),
}))

